import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { CooperativaUsuariosTenantService } from '../cooperativa/cooperativa-usuarios-tenant.service';
import { getActiveCooperativaId, setActiveCooperativaId } from '../cooperativa/active-cooperativa.storage';

export const authGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const coopUsuarios = inject(CooperativaUsuariosTenantService);

  await authService.authReady();

  if (!authService.isAuthenticated()) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url || '/home' } });
    return false;
  }

  try {
    await authService.ensureUserDocument();
  } catch (err) {
    console.error('[authGuard] Error al asegurar documento users/{uid}:', err);
    router.navigate(['/login']);
    return false;
  }

  try {
    const recienVinculadas = await coopUsuarios.vincularInvitacionesPendientes();
    if (!getActiveCooperativaId() && recienVinculadas.length > 0) {
      setActiveCooperativaId(recienVinculadas[0]);
    }
  } catch (e) {
    console.warn('[authGuard] No se pudieron vincular invitaciones a la cooperativa:', e);
  }

  return true;
};
